import * as React from "react"

import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material"
import { EntryBase } from "./components/EntryBase";
import { Header } from "./components/Header"
import { Footer } from "./components/Footer";
import { Blockage } from "./components/Blockage";
import { ServerError } from "./components/ServerError";
import { ContractConfirm } from "./components/ContractConfirm";
import { ContractInfo } from "./components/ContractInfo";
import { ContractEdit } from "./components/ContractEdit";
import { PaymentEdit } from "./components/PaymentEdit";
import { PaymentLog } from "./components/PaymentLog";
import { ContractList } from "./components/ContractList";
import { ContractUpdate } from "./components/ContractUpdate";
import LogoutPage from "./components/LogoutPage";
import PageNotFound from "./components/PageNotFound";
import { Admin } from "./components/Admin";
import User from "./components/User";
import { GmoFailed, GmoSuccess } from "./components/GmoResult";
import { EmailUnverified } from "./components/EmailUnverified";
import { ThankyouForRequest } from "./components/ThankyouForRequest";


const App = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} flexWrap={"nowrap"} height={"98vh"}>
      <Header flex={0} sx={{ margin: 0, padding: 0 }} />
      <Box flex={1} height={"2000px"} overflow={"auto"} paddingTop={5}>
        <Routes>
        <Route path='/entry' element={<EntryBase />} />
        <Route path='/thankyou' element={<ThankyouForRequest />} />
        <Route path='/gmo/success' element={<GmoSuccess />} />
        <Route path='/gmo/failed' element={<GmoFailed />} />

          <Route path='/user' element={<User />}>
            <Route path='/user' element={<ContractConfirm />} />
            <Route path='/user/info' element={<ContractInfo />} />
            <Route path='/user/edit' element={<ContractEdit />} />
            <Route path='/user/paymentLog' element={<PaymentLog />} />
            <Route path='/user/paymentEdit' element={<PaymentEdit />} />
          </Route>

          <Route path='/admin' element={<Admin />}>
            <Route path='/admin' element={<ContractList />} />
            <Route path='/admin/update/:memberId' element={<ContractUpdate />} />
          </Route>

          <Route path='/logout' element={<LogoutPage />} />

          <Route path='/emailUnverified' element={<EmailUnverified />} />
          <Route path='/blockage' element={<Blockage />} />
          <Route path='/serverError' element={<ServerError />} />
          <Route path="*" element={<PageNotFound />} />

        </Routes>
      </Box>
      <Footer flex={0} />
    </Box>
  )
}

export default App